
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.footer-wave-bg{
  background-image:url("data:image/svg+xml,%3Csvg width='239' height='660' viewBox='0 0 239 660' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M560.575 605.828C576.275 563.477 588.853 508.449 602.512 438.713C608.339 408.986 614.362 376.587 620.91 341.35C628.677 299.579 637.18 253.826 646.977 203.829C654.192 167.013 662.099 127.892 670.923 86.3711C672.032 81.1866 673.084 76.0076 674.104 70.8222C708.13 -102.735 692.795 -271.061 639.737 -407.856C638.402 -391.305 636.209 -375.448 633.229 -360.257C617.36 -279.243 579.225 -217.091 530.675 -167.555C459.793 -95.2224 366.671 -49.6046 287.65 -10.8907C285.476 -9.82585 283.314 -8.76709 281.162 -7.71623C240.981 11.9782 204.765 29.999 177.508 48.9541C163.884 58.4276 152.495 68.1429 143.984 78.3655C135.463 88.6009 129.825 99.2887 127.569 110.819C125.428 121.745 126.292 133.509 130.774 146.501C141.141 176.532 142.663 201.676 138.244 224.146C131.122 260.371 108.868 289.314 84.3709 321.167C81.3737 325.063 78.3477 329.004 75.3106 333.003C47.3895 369.74 18.5766 411.638 6.58226 472.866C-2.82169 520.85 -1.91454 580.81 18.023 659.597C19.2054 659.901 20.3803 660.225 21.5619 660.546C23.6827 661.128 25.8053 661.705 27.9289 662.192C101.78 679.021 165.033 693.192 219.426 703.844C365.445 732.472 447.719 735.591 499.971 697.055C526.109 677.809 544.877 648.175 560.575 605.828Z' fill='%23002536'/%3E%3C/svg%3E");
  background-repeat:no-repeat;
  background-position:right top;
  background-color:var(--blue-responsible-darken-2);
}

.footer-navigation {
  color: var(--cyan-near-lighten-5);
}

.footer-navigation.mobile {
  display: block;
  grid-template-columns: repeat(9, minmax(0, 1fr));
  grid-template-rows: repeat(3, minmax(0, 1fr));
  text-align: center;
}

.footer-bottom--wrapper {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-bottom: 10rem;
  color: var(--cyan-near-lighten-5);
}

@media (min-width: 1280px) {

  .footer-bottom--wrapper {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .footer-bottom--wrapper {
    padding-bottom: 9rem;
  }
}

@media (min-width: 1440px) {

  .footer-bottom--wrapper {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .footer-bottom--wrapper {
    padding-bottom: 10rem;
  }
}

@media screen and (max-width: 1024px){
  .footer-bottom--wrapper {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .footer-bottom--wrapper {
    padding-bottom: 0px;
  }
}

.footer-bottom--content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 1rem;
  padding-right: 1rem;
  text-align: center;
}

@media (min-width: 1024px) {

  .footer-bottom--content {
    flex-direction: row;
  }

  .footer-bottom--content {
    justify-content: space-between;
  }

  .footer-bottom--content {
    padding-left: 5rem;
    padding-right: 5rem;
  }
}

@media (min-width: 1280px) {

  .footer-bottom--content {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
}

@media (min-width: 1440px) {

  .footer-bottom--content {
    padding: 1rem;
  }
}

.footer-social {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 2rem;
  display: flex;
  flex-grow: 0;
  flex-direction: row;
}

@media (min-width: 1024px) {

  .footer-social {
    margin-left: 0px;
    margin-right: 0px;
  }

  .footer-social {
    margin-bottom: 0px;
  }
}

@media (min-width: 1280px) {

  .footer-social {
    margin-bottom: 1.5rem;
  }
}

@media (min-width: 1440px) {

  .footer-social {
    margin-bottom: 2rem;
  }
}

.footer-logos {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: row;
}

@media (min-width: 1024px) {

  .footer-logos {
    margin-left: 0px;
    margin-right: 0px;
  }

  .footer-logos {
    margin-bottom: 0px;
  }
}

@media (min-width: 1280px) {

  .footer-logos {
    margin-bottom: 1.5rem;
  }
}

@media (min-width: 1440px) {

  .footer-logos {
    margin-bottom: 2rem;
  }
}
`;